
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"17","height":"21","viewBox":"0 0 17 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.636 2.09a1.045 1.045 0 010-2.09h14.09a1.045 1.045 0 010 2.09H1.637zm0 6.273a1.045 1.045 0 010-2.09h10.272a1.045 1.045 0 110 2.09H1.636zm0 6.272a1.045 1.045 0 110-2.09H8.09a1.046 1.046 0 010 2.09H1.636zM.591 19.86a1.045 1.045 0 001.045 1.046h2.635a1.046 1.046 0 000-2.09H1.636A1.045 1.045 0 00.591 19.86z","fill":"#000"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Lead/assets/sort.svg
// module id = 42xZ
// module chunks = 1